import { TEMPLATE_TAG_COLORS, TEMPLATE_TAGS } from 'src/data/templates';

export const useTemplateTags = ({ isCsvTemplate }) => {
  const tagLabel = isCsvTemplate ? TEMPLATE_TAGS.csv : TEMPLATE_TAGS.multiPrompt;
  const tagColor = isCsvTemplate ? TEMPLATE_TAG_COLORS.purple : TEMPLATE_TAG_COLORS.yellow;

  return { tagLabel, tagColor };
};
